import { SECTION_NAMES } from '@repo/common';

const nameMapping: Record<string, string> = {
  [SECTION_NAMES.TOP]: SECTION_NAMES.TOP_GAMES,
  [SECTION_NAMES.TRENDING_GAMES]: SECTION_NAMES.TRENDING,
  [SECTION_NAMES.NEW_REL]: SECTION_NAMES.NEW_RELEASES,
};

export const getSectionName = (name: string): string => {
  return nameMapping[name] || name;
};
